module.exports = __webpack_public_path__ + "434ba4c5473a2cbe75a29fbc71a08557.svg";